import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

export function equalValidator(
  otherControlName: string,
  propToCompare?: string
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.parent) {
      if (propToCompare)
        return control.parent.get(otherControlName).value?.[propToCompare] ===
          control.value?.[propToCompare]
          ? null
          : { equal: true };
      else
        return control.parent.get(otherControlName).value === control.value
          ? null
          : { equal: true };
    } else {
      return null;
    }
  };
}
